import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, Skeleton } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import HorizontalBarChart from 'examples/Charts/BarCharts/HorizontalBarChart';

function TopCountriesChart({ countries, counts, loading, title = 'Top Countries by Players' }) {
  const chartData = useMemo(() => {
    if (!countries || !counts || countries.length === 0) {
      return null;
    }

    const combined = countries.map((country, i) => ({
      country: country || 'Unknown',
      count: counts[i] || 0
    }));

    const sorted = combined.sort((a, b) => b.count - a.count).slice(0, 10);

    return {
      labels: sorted.map((c) => c.country),
      datasets: [
        {
          label: 'Players',
          data: sorted.map((c) => c.count),
          color: 'info'
        }
      ]
    };
  }, [countries, counts]);

  if (loading) {
    return (
      <Card>
        <MDBox p={3}>
          <Skeleton variant='text' width={200} height={32} />
          <Skeleton variant='rectangular' height={300} sx={{ mt: 2 }} />
        </MDBox>
      </Card>
    );
  }

  if (!chartData) {
    return (
      <Card>
        <MDBox p={3}>
          <MDTypography variant='h6' fontWeight='medium'>
            {title}
          </MDTypography>
          <MDBox display='flex' justifyContent='center' alignItems='center' py={4}>
            <MDTypography variant='body2' color='text'>
              No country data available
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    );
  }

  return (
    <HorizontalBarChart title={title} description='Top 10 countries by player count' chart={chartData} height='300px' />
  );
}

TopCountriesChart.defaultProps = {
  countries: [],
  counts: [],
  loading: false,
  title: 'Top Countries by Players'
};

TopCountriesChart.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.string),
  counts: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool,
  title: PropTypes.string
};

export default TopCountriesChart;
